import React from 'react';
import MyGlobe from '../components/MyGlobe';


import './GlobePage.css';


const GlobePage: React.FC = () => {

  return (
    <div className='globe-page'>
        <MyGlobe />
    </div>
  );
};

export default GlobePage;
